<template >
    
  <v-app style='background-color: #f8f8f8;'>
    <!-- <div style="width: 100%; height: 100%; position: absolute; top:50; left:0;">
        <vue-particles
          :color="$mainColor"
          :particleOpacity="0.7"
          :particlesNumber="150"
          shapeType="circle"
          :particleSize="4"
          :linesColor="$mainColor"
          :linesWidth="2"
          :lineLinked="true"
          :lineOpacity="0.3"
          :linesDistance="120"
          :moveSpeed="2"
          :hoverEffect="true"
          hoverMode="grab"
          :clickEffect="true"
          clickMode="push"
        >
        </vue-particles>
      </div> -->

    <Header v-if="$route.name !== 'Home'" />
    <HelperDialog/>
    <router-view/>

    <div style="z-index: 205;" v-if="isLoggedIn && (GETTERS_HAVE_ROLE('msc_admin') || GETTERS_HAVE_ROLE('moderator'))">
      <calendar-modal
      :input_station_id="null"
      />
    </div>

    <div v-if="isLoggedIn && (GETTERS_HAVE_ROLE('msc_admin') || GETTERS_HAVE_ROLE('bs') || GETTERS_HAVE_ROLE('moderator') || GETTERS_HAVE_ROLE('expert') || GETTERS_HAVE_ROLE('user_administrator'))">
      <proposal-global-modal/>
    </div>

    <div v-if="isLoggedIn && (GETTERS_HAVE_ROLE('moderator'))">
      <user-global-modal/>
    </div>

    <template v-if="GETTERS_PROFILE !== null">
      <widget-archive-proposal
      v-if="!archive" 
      @archive-hide="switchArchive"/>
    </template>
    <v-dialog v-model="GETTERS_OVERLAY">
        <v-overlay :value="GETTERS_OVERLAY">
            <v-progress-circular
                size="64"
                indeterminate
                color="grey"
            ></v-progress-circular>
        </v-overlay>
    </v-dialog>
  </v-app>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import Header from './components/Common/Header.vue'
import HelperDialog from './components/Common/HelperDialog.vue'
import CalendarModal from './components/Admin/BS/CalendarModal.vue';
import ProposalGlobalModal from './components/Proposals/ProposalGlobalModal.vue';
import UserGlobalModal from './components/User/userGlobalModal.vue';
import WidgetArchiveProposal from './components/widgets/archive-proposal'
import axios from 'axios';
import { AUTH_URL, REFERENCES_URL } from '../vars';
import user from '../src/assets/user.png';


export default {
  name: 'App',
  components: {
    HelperDialog,
    Header,
    WidgetArchiveProposal,
    CalendarModal,
    ProposalGlobalModal,
    UserGlobalModal,
  },
  data() {
    return {
      archive: '',
    }
  },
  beforeMount() {
    
    if (this.GETTERS_TOKEN === null && localStorage.getItem('token')) {
      this.getDataServicesStart()
    }
  },
  methods: {
    ...mapActions([
      'logged', 
      'GET_PROFILE',
      'LOAD_EQUIMENT',
      'LOAD_SAMPLETYPES',
      'LOAD_BS',
    ]),
    ...mapMutations([
      'UPDATE_USER',
      'UPDATE_AVATAR',
      'UPDATE_NAME_USER',
      'SET_APP_LANGUAGE',
    ]),
    switchArchive() {
      this.archive = !this.archive
    },
    async getDataServicesStart(val) {
      try {
        
          await this.logged({ token: val });
          await this.GET_PROFILE(localStorage.isLoggedIn)  
          await this.UPDATE_NAME_USER(this.GETTERS_PROFILE.data.profiles[0].individual.last_name + ' ' + this.GETTERS_PROFILE.data.profiles[0].individual.first_name)
          await this.UPDATE_USER(this.GETTERS_PROFILE.data.profiles[0])
          await this.UPDATE_AVATAR(this.GETTERS_PROFILE.data)
          
          await this.LOAD_SAMPLETYPES()
          await this.LOAD_EQUIMENT()
          await this.LOAD_BS()

          // тут проблема с яхыком
          // await this.SET_APP_LANGUAGE()
          // this.$i18n.locale = await this.GETTERS_PROFILE.data.profiles[0].language;


      } catch (ex) {
        console.log('APP ', ex);
      }
    },
  },

  computed: {
    ...mapGetters([
      'GETTERS_LOGIN',
      'GETTERS_PROFILE',
      'GETTERS_TOKEN',
      'GETTERS_OVERLAY',
      'GETTERS_APP_LANGUAGE_NTRANSLATE',
      'GETTERS_HAVE_ROLE',
    ]),

    isLoggedIn() {
      return localStorage.isLoggedIn;
    },
  },
  watch: {
    GETTERS_TOKEN(val) {
      localStorage.setItem('token', val)

      this.getDataServicesStart(val)
    },
    GETTERS_PROFILE(val) {
      this.archive = val.data.profiles[0].individual.attached_old_proposals
      if (val.data.profiles[0].individual.update_personal_data ){
        if (this.$route.path != '/personal-data') location.href = '/personal-data'
      }
    },

  }
};
</script>
<style lang="scss">

  $success-toast-color: #4CAF50;
  $error-toast-color: #FF5252;
  $warning-toast-color: #FFC107;
  $default-toast-color: grey;

  *, body, html {
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    
  }
  .main-container{
    margin-top: 80px !important;
    margin-right: 55px !important;
    margin-bottom: 60px !important;
    margin-left: 5px !important;
    height: 100%;
    

  }
  .p-l-15 {
    padding-left: 15px;
  } 
  .p-r-15 {
    padding-right: 15px;
  }
  .switch-login {
    position: absolute;
    top: 25px;
    left: 54%;
  }
  .switch{
    margin-top: 0;
    margin-left:10px;

    .v-input--selection-controls {
        margin-top: 0 !important;
    }
  }

  .switch__current-lang {
    padding-top:3px;
    font-size: 16px;
    margin-right: 10px;
    color: rgba(0, 0, 0, 0.6);
  }

  .help-name-page {
    position: absolute;
    top: 6%;
    right: 10px;
    color: #15336D;
    z-index: 1;
  }
  .mb-12.wrapper.v-card.v-sheet.theme--light.white{
    box-shadow: none;
  }
  .v-stepper__header{
    box-shadow: none;
  }
  .theme--light.v-stepper.v-stepper__header.v-divider{
    background-color: #15336d;
  }
  .v-application .primary{
    background-color: #15336d !important;
  }
  *, body, html{
    box-shadow: none;
  }
  .v-stepper.header-stepper.theme--light{
    box-shadow: none;
  }
  .v-application--is-ltr .v-stepper__label {
    text-align: center !important;
  }
  .Vue-Toastification__toast {
    min-height: 54px !important;
    padding: 16px 24px !important;
    background: white !important;
  }

  .Vue-Toastification__toast--warning,
  .Vue-Toastification__close-button {
    color: $warning-toast-color !important;
  }
  .Vue-Toastification__toast--success,
  .Vue-Toastification__close-button {
    color: $success-toast-color !important;
  }
  .Vue-Toastification__toast--error,
  .Vue-Toastification__close-button {
    color: $error-toast-color !important;
  }
  .Vue-Toastification__toast--info,
  .Vue-Toastification__close-button {
    color: $default-toast-color !important;
  }
  .error-input {
    border: 2px solid #ff5252 !important;
    color: #ff5252;
  }
</style>
